<template>
  <section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" lazy-validation>
            <v-card-title>Modification Thème</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="themeInfo.title"
                    label="Titre"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <vue-upload-multiple-image
                    v-if="themeInfo.title"
                    style="margin-left: 160px"
                    v-model="images"
                    accept="image/*	"
                    :data-images="images"
                    name="images"
                    drag-text="Veuillez ajoutez une images svp!"
                    browse-text="Browse image"
                    primary-text="Primary image"
                    mark-is-primary-text="Set default image"
                    :min-image="1"
                    :multiple="false"
                    :showEdit="false"
                    popup-text="Description default image"
                    drop-text="Drag and drop"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                  >
                  </vue-upload-multiple-image>
                  <v-progress-linear
                    v-if="showlowding && uploadPercentage < 100"
                    style="max-width: 190px; margin-left: 160px"
                    color="primary"
                    indeterminate
                    rounded
                    height="15"
                    ><strong
                      >{{ Math.ceil(uploadPercentage) }}%</strong
                    ></v-progress-linear
                  >
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <VueEditor
                    v-model="themeInfo.description"
                    auto-grow
                    outlined
                    label="Description"
                    placeholder="Description"
                  >
                  </VueEditor>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="themeInfo.rank"
                    hide-details
                    outlined
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    label="Rank Theme"
                  />
                </v-col>
                <v-col cols="auto" style="margin-top: 16px">
                  <span>Premium:</span>
                </v-col>
                <v-col cols="auto">
                  <v-switch
                    v-model="themeInfo.isLocked"
                    hide-details
                    inset
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      :disabled="
                        themeInfo.rank.length <= 0 ||
                        themeInfo.title.length <= 0 ||
                        themeInfo.description.length <= 0
                      "
                      class="info"
                      @click="UpdateTheme()"
                    >
                      Suivant
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>
<script>
import firebase from "firebase/compat/app";
import store from "../../../store/image";

import "firebase/compat/storage";
import { component as VueCodeHighlight } from "vue-code-highlight";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import axios from "axios";
import Constant from "@/utils/constants";
import { getAllSurat, getAllTheme } from "@/views/qorani/services/services";
export default {
  components: { VueUploadMultipleImage, VueEditor, VueCodeHighlight },
  data() {
    return {
      isLocked: false,
      uploadPercentage: null,
      fakePercentage: null,
      showlowding: false,
      images: [],
      themeInfo: {
        id: "",
        title: "",
        description: "",
        imgUrlId: "",
        rank: "",
        isLocked: false,
      },
      themes: [],
      theme: {
        ThemeId: "",
        title: "",
        description: "",
        imgDBUrlId: "",
        rank: "",
        isLocked: false,
      },
      imageInfo: {
        fileName: "",
        fileUrl: "",
      },
    };
  },

  async beforeRouteEnter(to, from, next) {
    const ThemeId = to.params.id;
    try {
      const response = await axios.get(
        `${Constant.QORANI}theme/get/${ThemeId}`
      );
      next((vm) => {
        vm.themeInfo = response.data;

        const imagePath = response.data.imgDBId
          ? vm.getImageUrl(response.data.imgDBId)
          : response.data.imageUrl;

        vm.images.push({
          name: "",
          path: imagePath,
          highlight: 1,
          default: 1,
        });
      });
    } catch (error) {
      console.error("Error fetching product details:", error);
      next(null);
    }
  },

  methods: {
    async filterFirebaseUrls() {
      for (const theme of this.themes) {
        const firebaseUrls = theme.listFileUrl.filter((url) =>
          url.includes("firebase")
        );
        if (firebaseUrls.length > 0) {
          console.log(`theme ID: ${theme.id}, Firebase URLs:`, firebaseUrls);
          await this.uploadFirebaseUrls(theme.id, firebaseUrls);
        }
      }
    },

    async uploadFirebaseUrls(ThemeId, firebaseUrls) {
      const formDataToSend = new FormData();
      try {
        // Fetch the image as a blob
        const response = await fetch(firebaseUrls);
        const blob = await response.blob();

        formDataToSend.append("file", blob, "image.jpg");
      } catch (error) {
        console.error(
          `Error converting image URL to File for Theme ID ${ThemeId}:`,
          error
        );
        return; // Exit function in case of an error
      }

      console.log(formDataToSend);

      try {
        // Upload the image
        const response = await fetch(`${Constant.QORANI}fileDB/upload`, {
          method: "POST",
          body: formDataToSend,
        });

        if (!response.ok) {
          const errorResponse = await response.json();
          console.error(
            `Failed to upload URLs for Theme ID:`,
            response.statusText,
            errorResponse
          );
        } else {
          const result = await response.json();
          console.log(`Successfully uploaded URLs for Theme ID:`, result);

          if (result.id) {
            // Update the theme with the uploaded image DB URL
            this.theme.imgDBUrlId = result.id;
            this.theme.title = this.themeInfo.title;
            this.theme.description = this.themeInfo.description;
            this.theme.rank = this.themeInfo.rank;
            this.theme.isLocked = this.themeInfo.isLocked;
            console.log("imgDBUrlId:", this.theme.imgDBUrlId);

            try {
              // Perform the theme update
              const responseCategorie = await fetch(
                `${Constant.QORANI}theme/edit/${this.themeInfo.id}`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(this.theme),
                }
              );

              if (!responseCategorie.ok) {
                const errorResponse = await responseCategorie.json();
                console.error(
                  "Failed to update theme:",
                  responseCategorie.statusText,
                  errorResponse
                );
              } else {
                const resultCategorie = await responseCategorie.json();
                console.log("Successfully updated theme:", resultCategorie);
              }
            } catch (error) {
              console.error(
                `Error while updating theme for ID ${this.themeInfo.id}:`,
                error
              );
            }
          }
        }
      } catch (error) {
        console.error(`Error while uploading URLs for Theme ID:`, error);
      }
    },
    async loadImage(item) {
      if (item.fileUrlDBType === "svg") {
        try {
          const response = await fetch(
            `${Constant.QORANI}fileDB/files/${item.fileUrlDBId}`
          );
          if (!response.ok)
            throw new Error("Échec du chargement de l'image SVG");

          let svgContent = await response.text();

          // Ajoute width et height directement dans le SVG
          svgContent = svgContent
            .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

          item.svgContent = svgContent; // Stockage dans l'objet item
        } catch (error) {
          console.error("Erreur lors du chargement de l'image :", error);
        }
      } else {
        item.imgUrl = `${Constant.QORANI}fileDB/files/${item.fileUrlDBId}`;
      }
    },

    getImageUrl(imgDBId) {
      return `${Constant.QORANI}fileDB/files/${imgDBId}`;
    },
    async UpdateTheme() {
      const imageId = store.state.imageId;

      this.theme.title = this.themeInfo.title;
      this.theme.description = this.themeInfo.description;

      // this.theme.imgUrlId = this.themeInfo.imgId;
      this.theme.rank = this.themeInfo.rank;
      this.theme.isLocked = this.themeInfo.isLocked;
      const responseCategorie = await fetch(
        Constant.QORANI + "theme/edit/" + this.themeInfo.id,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.theme),
        }
      );

      try {
        this.$router.push({
          name: "Theme",
        });
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout du theme, veuillez réessayez plus tard, Merci."
        );
      }
    },

    async uploadImageSuccess(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
        const imageId = store.state.imageId;
        this.theme.imgDBUrlId = imageId;
        console.log("Image id :", imageId);
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },
    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.images.indexOf(fileList[index].path);
        this.themeInfo.imageUrl = "";
        this.themeInfo.imgId = "";
        if (index > -1) {
          this.images.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    convertImagePathToFile(element) {
      const byteString = atob(element.path.split(",")[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: "image/jpeg" });

      return new File([blob], element.name);
    },
  },
  async created() {},
};
</script>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
